var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWdownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17.005,
    viewBox: "0 0 17 17.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "c4f399f08f0b920b75183985b2fe3036",
    d: "M12.455,15.011l-1.1,1.106V11.361a.851.851,0,1,0-1.7,0v4.756l-1.1-1.106A.854.854,0,1,0,7.35,16.219L9.9,18.771a.851.851,0,0,0,.281.179.8.8,0,0,0,.647,0,.851.851,0,0,0,.281-.179l2.552-2.552a.854.854,0,0,0-1.208-1.208Zm3.514-9.418A5.956,5.956,0,0,0,4.6,7.2a3.4,3.4,0,0,0,.8,6.713.851.851,0,1,0,0-1.7,1.7,1.7,0,1,1,0-3.4.851.851,0,0,0,.851-.851,4.254,4.254,0,0,1,8.278-1.37.851.851,0,0,0,.664.57,2.552,2.552,0,0,1,.2,4.969.852.852,0,0,0,.425,1.651,4.254,4.254,0,0,0,.145-8.185Z",
    transform: "translate(-1.991 -2.013)",
    fill: "#146ae3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWdownload);
export default __webpack_public_path__ + "static/media/wdownload.b962786b2b925f0f75de7b70c7f3ba21.svg";
export { ForwardRef as ReactComponent };